import React from "react";
import { Button, Row, Table } from "react-bootstrap";

const RefundList = ({ refundData, refundEditAction, handleRefundDelete }) => {

  return (
    refundData.length > 0 && (
      <Table
        bordered
        className="mt-2"
      >
        <thead>
          <tr>
            <th className="text-left">ARN Number</th>
            <th className="text-left">ARN Date</th>
            <th className="text-left">Status</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {refundData.map((data) => (
            <tr key={data.id}>
              <td className="text-left">{data.arn_no}</td>
              <td className="text-left">{data.arn_date}</td>
              <td className="text-left">{data.status.name}</td>
              <td className="text-center">
                <Button
                  variant="primary"
                  size="sm"
                  className="me-2 fw-bold"
                  onClick={() => refundEditAction(data)}
                  style={{width:"100px"}}
                >
                  Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="fw-bold "
                  onClick={() => handleRefundDelete(data.id)}
                  style={{width:"100px"}}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  );
};

export default RefundList;
